import React from 'react'
import { FireIcon } from '@components/Icons'
import { useTranslation } from 'react-i18next'
import SearchStyle from '../style'
import Chip, { ChipVariant } from '@components/DesignSystem/Chip'
import tw from 'twin.macro'
import styled from 'styled-components'

interface TrendingKeywordsProps {
  data?: string[]
  keywordOnClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void
}

export default function TrendingKeywords(props: TrendingKeywordsProps) {
  const { t } = useTranslation('search')
  const { data, keywordOnClick } = props
  return (
    <>
      <div className="title">
        <FireIcon />
        <SearchStyle.Title>{t(['hotSearch', '熱門搜尋'])}</SearchStyle.Title>
      </div>
      <div className="content">
        {data?.slice(0, 10).map((value) => (
          <StyledChip key={value} variant={ChipVariant.default} onClick={keywordOnClick}>
            {value}
          </StyledChip>
        ))}
      </div>
    </>
  )
}

const StyledChip = styled(Chip)`
  ${tw`mr-2 mb-4 inline-block cursor-pointer`}
`
